import React from 'react';
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import PropTypes from 'prop-types';
import BaseComponent from '../BaseComponent';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import NumberInput from "../Widget/NumberInput";
import ValidatorLabel from "../Widget/ValidatorLabel";

/*= (message, okCallback, cancelCallback) =>*/

export default class ComponentItemDialog extends BaseComponent {

    constructor(props){
        super(props);
        let state = this.state
        state.componentItem = this.props.componentItem
        state.modal = this.props.modal
        state.labelError = undefined
        state.descriptionError = undefined
        state.lengthError = undefined
        // this.setState(state)
    }

    componentWillReceiveProps(props, nextContext) {
        if(this.props!=props){
            this.setState({
                modal:props.modal,
                componentItem:props.componentItem,
                labelError:undefined,
                descriptionError:undefined,
                lengthError:undefined,
            })
        }
    }

    updateComponentItem=()=>{
        let {labelError, descriptionError, lengthError, componentItem} = this.state
        labelError = undefined
        descriptionError = undefined
        lengthError = undefined
        let componentLabel = componentItem.label
        let description = componentItem.description
        let length = componentItem.length
        let valid = true
        if(!componentLabel || componentLabel===''){
            labelError = label.EnterLabel
            valid = false
        }
        if(!description || description===''){
            descriptionError = label.EnterDescription
            valid = false
        }
        if(!length || length===''){
            lengthError = label.EnterCharacterLength
            valid = false
        }
        this.setState({labelError, descriptionError, lengthError}, () => {
            if(valid){
                if(!componentItem.id){
                    componentItem.id = -Date.now();
                    componentItem.created = new Date()
                    componentItem.updated = new Date()
                }
                this.props.okCallback(componentItem)
            }
        })
    }


    render(){
        let {componentItem, labelError, descriptionError, lengthError} = this.state
        if(!componentItem.length){
            componentItem.length = 255
        }
        return (
            <Modal
                isOpen={this.state.modal}
                centered={true}
                size="lg"
                backdrop={true}>
                {super.render()}
                <ModalHeader>
                    {label.ComponentItem}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="label">{label.Title}</Label>
                                <Input
                                    type="text"
                                    name="label"
                                    value={componentItem.label}
                                    onChange={(e) =>{
                                        componentItem.label = e.target.value
                                        this.setState({
                                            componentItem
                                        })
                                    }}
                                    placeholder={label.EnterLabel}
                                />
                                {/*<WarningLabel show={labelError} message={labelError}/>*/}
                                <ValidatorLabel message={labelError}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="description">{label.Description}</Label>
                                <Input
                                    type="textarea"
                                    name="description"
                                    style={{height:'100px', verticalAlign:'text-top'}}
                                    value={componentItem.description}
                                    onChange={(e) =>{
                                        componentItem.description = e.target.value
                                        this.setState({
                                            componentItem
                                        })
                                    }}
                                    minLength={6}
                                    placeholder={label.EnterDescription}
                                />
                                {/*<WarningLabel show={descriptionError} message={descriptionError}/>*/}
                                <ValidatorLabel message={descriptionError}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="length">{label.CharacterLengthDefault(255)}</Label>
                                <NumberInput
                                    name="length"
                                    className="form-control"
                                    value={componentItem.length}
                                    onChangeEvent={(e, maskedvalue, floatvalue) => {
                                        e.preventDefault()
                                        componentItem.length = floatvalue
                                        this.setState({
                                            componentItem
                                        })
                                    }}
                                    placeholder="255"
                                    maxLength={3}>
                                </NumberInput>
                                <ValidatorLabel message={lengthError}/>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary" onClick={e=>{
                        e.preventDefault()
                        this.setState({
                            modal:false
                        }, () => {
                            if(this.props.cancelCallback!=null){
                                this.props.cancelCallback()
                            }
                        })
                    }}>
                        {label.Cancel}
                    </Button>
                    &nbsp;
                    <Button
                        color="warning" onClick={e=>{
                        e.preventDefault()
                        this.updateComponentItem()
                    }}>
                        {componentItem.id?label.Update:label.Save}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

ComponentItemDialog.propTypes = {
    modal: PropTypes.bool.isRequired,
    okCallback: PropTypes.func,
    cancelCallback:PropTypes.func,
    componentItem:PropTypes.object
}
